// extracted by mini-css-extract-plugin
module.exports = {"selectDay":"SelectDayCarousel_selectDay__2WLOu mixins_horizontalScroll__2qQnf","dayItem":"SelectDayCarousel_dayItem__1SfwC","selectedDay":"SelectDayCarousel_selectedDay__3rdfQ"};